import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiChartComponent } from '@fi-shared/fi-chart/fi-chart.component';
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';

@NgModule({
    imports: [CommonModule, BaseChartDirective],
    declarations: [FiChartComponent],
    providers: [provideCharts(withDefaultRegisterables())],
    exports: [FiChartComponent, BaseChartDirective],
})
export class FiChartModule {}
